import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {UserInfoStorageService} from './user-info-storage.service';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Error} from '../../model/error';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    public authService: UserInfoStorageService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.setHeaders(request)).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          const errorRet = new Error();

          if (error.status === 0) {
            // errorRet.message = error.statusText;
            // errorRet.type = Error.Type.UNKNOWN_ERROR;
            errorRet.message=error.message;
          } else if (error.error) {
            errorRet.message = error.error.message;
            errorRet.type = error.error.type;
            errorRet.fields = error.error.fields;
            errorRet.values = error.error.values;
          } else {
            // errorRet.message=error.message;
            errorRet.message = 'Unknown error';
          }

          return throwError(errorRet);
        }
        // Non-HTTP error (e.g. a JS exception thrown elsewhere in the pipe). Must still
        // return a stream here - catchError feeds this return value into innerFrom(), and
        // returning undefined throws "You provided 'undefined' where a stream was expected",
        // which then looks like the whole request silently died instead of surfacing the
        // real error.
        return throwError(error);
      })
    );
  }

  private setHeaders(request: HttpRequest<any>) {
    const headers: Record<string, string> = {
      'X-Requested-With': 'XMLHttpRequest'
    };
    if (!request.headers.has('Content-Type')) {
      headers['Content-Type'] = 'application/json';
    }
    // The session id now lives exclusively in the HttpOnly cookie set by the backend -
    // withCredentials makes the browser attach/accept it automatically, and it is never
    // read or written from JS (see UserInfoStorageService).
    return request.clone({ setHeaders: headers, withCredentials: true });
  }
}
